<template>
	<div class="tabulation">
		<el-card class="chart-card">
			<div style="margin-top: 20px;">
				<el-form ref="ruleFormRef" :model="form" :rules="rules" class="demo-ruleForm" :size="formSize"
					status-icon>
					<!-- 标题 -->
					<el-form-item label="标题名称" prop="name">
						<div class="aaaa">
							<el-input v-model="form.name" placeholder="请填写标题" size="large"></el-input>
						</div>
					</el-form-item>

					<!-- 说明 -->
					<el-form-item label="问卷说明" prop="desc">
						<div class="shuoming">
							<el-input type="textarea" v-model="form.desc" placeholder="请填写说明"></el-input>
						</div>
					</el-form-item>

					<!-- 答题时间 -->
					<el-form-item label="答题时间" prop="value1">
						<div class="bilke">
							<el-date-picker size="large" v-model="form.value1" type="datetimerange" range-separator="截至"
								start-placeholder="开始时间" end-placeholder="结束时间" :default-time="defaultTime2" />
						</div>
					</el-form-item>

					<!-- 展示专栏 -->
					<el-form-item label="展示专栏" prop="sex">
						<el-select v-model="form.sex" placeholder="请选择展示专栏" size="medium">
							<el-option label="直属机关工会" value="1"
								style="width:100%; text-align-last: center;"></el-option>
							<el-option label="基层工会" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>

					<!-- 可见组织 -->
					<el-form-item label="可见组织" prop="Mars">
						<el-input v-model="form.Mars" readonly placeholder="请选择组织名称" size="medium" style="width: 220px"
							@click="multiple"
							@change="numerical" />
					</el-form-item>

					<!-- 是否启用 -->
					<el-form-item label="是否发布" prop="enable">
						<el-select v-model="form.enable" placeholder="请选择是否发布" size="medium">
							<el-option label="是" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>

					<!-- 问卷模式 -->
					<el-form-item label="问卷模式" prop="pattern">
						<el-select v-model="form.pattern" placeholder="请选择问卷模式" size="medium">
							<el-option label="收集意见" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="答题模式" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>

					<!-- 时间限制 -->
					<el-form-item label="时间限制" prop="isSetTime">
						<el-select v-model="form.isSetTime" placeholder="请选择时间限制" size="medium">
							<el-option label="是" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>

					<!-- 答题时间 -->
					<el-form-item label="答题时间" prop="setTime" v-if="form.isSetTime == 1">
						<div class="aaaa">
							<el-input v-model="form.setTime" size="large" placeholder="请填写答题时间(分钟)"></el-input>
						</div>
					</el-form-item>

					<!-- 是否与健步配合答题 -->
					<el-form-item label="健步配合" prop="strides">
						<el-select v-model="form.strides" placeholder="请选择是否与健步配合答题" size="medium">
							<el-option label="是" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>

					<!-- 达标步数 -->
					<el-form-item label="达标步数" prop="reach">
						<div class="aaaass">
							<el-input v-model="form.reach" @keyup.native="onlyNumber('reach')" type="number"
								placeholder="请填写达标步数" size="large"></el-input>
						</div>
					</el-form-item>

					<!-- 达标题数 -->
					<el-form-item label="达标题数" prop="problem">
						<div class="aaaass">
							<el-input v-model="form.problem" @keyup.native="onlyNumber('problem')" type="number"
								placeholder="请填写达标题数" size="large"></el-input>
						</div>
					</el-form-item>

					<!-- 单次题数 -->
					<el-form-item label="单次题数" prop="einmal">
						<div class="aaaass">
							<el-input v-model="form.einmal" @keyup.native="onlyNumber('einmal')" type="number"
								placeholder="请填写单次题数" size="large"></el-input>
						</div>
					</el-form-item>

					<!-- 问题答尽后随机出题 -->
					<el-form-item label="随机出题" prop="random">
						<el-select v-model="form.random" placeholder="问题答尽后是否随机出题" size="medium">
							<el-option label="是" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>

					<!-- 限制每日答题次数 -->
					<el-form-item label="答题次数" prop="restrictive">
						<el-select v-model="form.restrictive" placeholder="是否限制答题次数" size="medium">
							<el-option label="按每日限制" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="按总次数限制" value="3"
								style="width:100%; text-align-last: center;"></el-option>
							<el-option label="不限制" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>

					<!-- 限制次数 -->
					<el-form-item label="限制次数" prop="frequency">
						<div class="aaaass">
							<el-input v-model="form.frequency" @keyup.native="onlyNumber('frequency')" type="number"
								placeholder="请填写答题次数" size="large"></el-input>
						</div>
					</el-form-item>

					<!-- 小程序端展示排行 -->
					<el-form-item label="展示排行" prop="exhibition">
						<el-select v-model="form.exhibition" placeholder="是否展示小程序端排行" size="medium">
							<el-option label="公开展示" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="管理员可见" value="2" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="全部不展示" value="3" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>

					<!-- 小程序端展示历史记录 -->
					<el-form-item label="展示记录" prop="record">
						<el-select v-model="form.record" placeholder="是否展示小程序端历史记录" size="medium">
							<el-option label="是" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>

					<!-- 标题图片 -->
					<el-form-item label="主题图片" prop="breviary">
						<el-upload action="/admin/ques/saveImage" list-type="picture-card" limit="2" ref="qingkong"
							v-model="form.breviary" :auto-upload="true" :on-change="change" :on-error="bedefeated"
							:on-success="succ" :on-remove="beforeremove" :on-preview="onpreview"
							accept=".jpeg,.png,.jpg,.bmp,.gif" :headers="header" name="imageFile"
							:class="styA === 0 ? 'styB' : 'styC'" :before-upload="beforeImageUpload">
							<el-icon>
								<Plus />
							</el-icon>
						</el-upload>

						<el-dialog v-model="dialogVisible">
							<img w-full :src="dialogImageUrl" alt="Preview Image" style="width:100%" />
						</el-dialog>
						<div class="referrals">( 推荐：图片尺寸 宽700px、高400px。)</div>
					</el-form-item>

					<!-- 答题问卷 -->
					<div class="sheet">
						<div class="dati">问卷</div>
						<div class="sheet_rifht">
							<div class="twist">
								<el-button type="primary" style="width: 90px;height: 30px;font-size: 16px;" size="small"
									@click="addQuestion">
									<el-icon class="cancel">
										<CirclePlus />
									</el-icon>新增
								</el-button>
							</div>
							<div class="shuomings" v-for="(item, qIndex) in topics" :key="item.id">
								<el-form-item label="问卷题目">
									<div class="circu">
										<el-input v-model="item.name" placeholder="请填写问卷题目" size="large"></el-input>
										<el-button size="default" @click="removeQuestion(qIndex)" class="red"
											:disabled="topics.length <= 1">
											<el-icon class="cancel">
												<Delete />
											</el-icon>删除
										</el-button>
									</div>
								</el-form-item>

								<el-form-item label="问卷类型">
									<el-radio-group v-model="item.type" size="large">
										<el-radio label="1">单选题</el-radio>
										<el-radio label="2">多选题</el-radio>
										<el-radio label="3">简答题</el-radio>
									</el-radio-group>
								</el-form-item>

								<!-- 单选 -->
								<div class="tance" v-show="item.type === '1'">
									<div class="fortify">
										<div class="subs">选项内容</div>
										<div>
											<el-button class="shallow" type="primary"
												style="width: 90px;height: 30px;font-size: 16px;" size="small"
												@click="addOption(item)">
												<el-icon class="cancel">
													<CirclePlus />
												</el-icon>新增
											</el-button>
										</div>
									</div>

									<div class="circus" v-for="opt in item.option" :key="opt.id">
										<el-input v-model="opt.name" class="w-50 m-2" size="large"
											placeholder="请填写选项内容" />

										<!-- 是否正确答案（仅当全局模式为答题模式时显示） -->
										<el-select v-show="form.pattern == 2" class="correct"
											v-model="opt.isCorrectAnswer" placeholder="是否正确答案" size="medium">
											<el-option label="是" value="1"
												style="width:100%; text-align-last: center;"></el-option>
											<el-option label="否" value="2"
												style="width:100%; text-align-last: center;"></el-option>
										</el-select>

										<el-button size="default" @click="removeOption(item, opt.id)" class="red">
											<el-icon class="cancel">
												<Delete />
											</el-icon>删除
										</el-button>
									</div>
								</div>

								<!-- 多选 -->
								<div class="tance" v-show="item.type === '2'">
									<div class="fortify">
										<div class="subs">选项内容</div>
										<div>
											<el-button type="primary" style="width: 90px;height: 30px;font-size: 16px;"
												size="small" @click="addOption(item)">
												<el-icon class="cancel">
													<CirclePlus />
												</el-icon>新增
											</el-button>
										</div>
									</div>

									<div class="circus" v-for="opt in item.option" :key="opt.id">
										<el-input v-model="opt.name" class="w-50 m-2" size="large"
											placeholder="请填写选项内容" />

										<!-- 是否正确答案（仅当全局模式为答题模式时显示） -->
										<el-select v-show="form.pattern == 2" class="correct"
											v-model="opt.isCorrectAnswer" placeholder="是否正确答案" size="medium">
											<el-option label="是" value="1"
												style="width:100%; text-align-last: center;"></el-option>
											<el-option label="否" value="2"
												style="width:100%; text-align-last: center;"></el-option>
										</el-select>

										<el-button size="default" @click="removeOption(item, opt.id)" class="red">
											<el-icon class="cancel">
												<Delete />
											</el-icon>删除
										</el-button>
									</div>
								</div>

								<!-- 简答题 -->
								<div class="tance" v-show="item.type === '3'">
									<div class="fortify">
										<div class="subs">是否必填</div>
										<el-select v-model="item.isRequired" placeholder="请选择" size="medium">
											<el-option label="是" value="1"
												style="width:100%; text-align-last: center;"></el-option>
											<el-option label="否" value="2"
												style="width:100%; text-align-last: center;"></el-option>
										</el-select>
									</div>
								</div>
							</div>
						</div>



					</div>
				</el-form>
			</div>

			<el-button class="button" type="primary" size="large" style="margin-top: 20px;" :loading="ConfirmLoading"
				@click="onSubmit">
				提交
			</el-button>
		</el-card>

		<!-- 所属组织弹窗 -->
		<div>
			<el-dialog v-model="visible" title="所属组织" width="500px" top="10vh" custom-class="organization-dialog" :close-on-click-modal="true" destroy-on-close>
				<el-tree :data="texture" :props="defaultProps" accordion @node-click="dendrogram" />
				<template #footer><el-button type="primary" @click="visible = false">确定</el-button></template>
			</el-dialog>
		</div>
	</div>
</template>

<script setup>
/* eslint-disable */
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { ref, reactive, onMounted } from 'vue'
import { Plus, CirclePlus, Delete } from '@element-plus/icons-vue'
import * as imageConversion from 'image-conversion'
import { DTadd, Zzlist } from '../../utils/api'
import { useStore } from 'vuex'
import qs from 'qs'
import { ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'

// ---------- 辅助函数 ----------
let idCounter = 0
const genId = (prefix = '') => {
	idCounter += 1
	return `${prefix}${Date.now()}_${idCounter}`
}

// ---------- refs / reactive ----------
const route = useRoute()
const router = useRouter()
const store = useStore()

const ruleFormRef = ref(null)
const qingkong = ref(null)
const defaultTime2 = [
	new Date(2000, 1, 1, 0, 0, 0),
	new Date(2000, 2, 1, 23, 59, 59),
]

// header for upload
const header = ref({
	timeout: 10000,
	accessToken: sessionStorage.getItem('token'),
})

// 图片上传相关
const dizhi = ref('')
const styA = ref(0)
const dialogVisible = ref(false)
const dialogImageUrl = ref('')
const succ = (res) => {
	dizhi.value = res.data
}
const change = (res, fileList) => {
	styA.value = fileList.length
	form.breviary = fileList
}
const bedefeated = (err) => {

}
const beforeImageUpload = (File) => {
	let isLt2M = File.size / 1024 / 1024 < 1
	return new Promise((resolve) => {
		if (isLt2M) {
			resolve(File)
		} else {
			imageConversion.compressAccurately(File, 950).then((res) => {
				resolve(res)
			})
		}
	})
}
const onpreview = (File) => {
	dialogVisible.value = true
	dialogImageUrl.value = File.url
}
const beforeremove = (File, fileList) => {
	styA.value = 0
}
const Remove = (file) => {

}

// 组织选择弹窗 & 列表
const visible = ref(false)
const defaultProps = {
	children: 'unionDtoList',
	label: 'unionName',
}
const texture = ref([])
const Hcode = ref('')
const multiple = (event) => {
	event?.target?.blur()
	visible.value = true
}
const dendrogram = (node) => {
	form.Mars = node.unionName
	Hcode.value = node.unionCode
}

// 初始化组织列表
const lang = () => {
	Zzlist().then((res) => {
		if (res && res.data) texture.value = res.data.data.wholeUnionList || []
	})
}

// 限制数字输入
const onlyNumber = (field) => {
	if (form[field]) {
		form[field] = String(form[field]).replace(/[^\d]/g, '')
	}
}

// ---------- 表单数据 ----------
const form = reactive({
	names: '',
	name: '',
	sex: '',
	desc: '',
	value1: '',
	enable: '',
	radio1: [],
	type: 1,
	pattern: '',
	frequency: '',
	record: '',
	exhibition: '',
	restrictive: '',
	random: '',
	strides: '',
	reach: '',
	problem: '',
	einmal: '',
	breviary: [],
	Mars: '',
	isSetTime: '',
	setTime: '',
})

// 表单校验
const rules = {
	pattern: [{ required: true, message: '请选择问卷模式', trigger: 'change' }],
	enable: [{ required: true, message: '请选择是否启用', trigger: 'change' }],
	value1: [{ required: true, message: '请选择时间', trigger: 'change' }],
	desc: [{ required: true, message: '请填写说明', trigger: 'change' }],
	name: [{ required: true, message: '请填写标题', trigger: 'change' }],
	sex: [{ required: true, message: '请选择分类', trigger: 'change' }],
	Mars: [{ required: true, message: '请选择组织', trigger: 'change' }],
	isSetTime: [{ required: true, message: '请选择时间限制', trigger: 'change' }],
	setTime: [{ required: true, message: '请填写答题时间', trigger: 'change' }],
}

// ---------- 问卷（每题独立） ----------
// topics: array of { id, name, type: '1'|'2'|'3', isRequired: '1'|'2', option: [{id, name, isCorrectAnswer}] }
const topics = ref([
	{
		id: genId('q_'),
		name: '',
		type: '1',
		isRequired: '1',
		option: [], // by default empty; user can add options
	},
])

// 新增题
const addQuestion = () => {
	topics.value.push({
		id: genId('q_'),
		name: '',
		type: '1',
		isRequired: '1',
		option: [],
	})
}

// 删除题（仅当前）
const removeQuestion = (index) => {
	if (topics.value.length <= 1) return
	topics.value.splice(index, 1)
}

// 新增选项（仅针对当前题）
// 初始化选项的 isCorrectAnswer 默认为 '2' (否)，保持和原逻辑一致
const addOption = (topicItem) => {
	topicItem.option.push({
		id: genId('o_'),
		name: '',
		isCorrectAnswer: '',
	})
}

// 删除选项（仅当前题）
const removeOption = (topicItem, optId) => {
	const idx = topicItem.option.findIndex((o) => o.id === optId)
	if (idx > -1) {
		topicItem.option.splice(idx, 1)
	}
}

// ---------- 其它逻辑（提交等） ----------
const ConfirmLoading = ref(false)
const value1 = ref([new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)])

const onSubmit = () => {
	// 时间处理（保留原有逻辑）
	try {
		const b = new Date(form.value1[0])
		const begin = `${b.getFullYear()}-${b.getMonth() + 1}-${b.getDate()} ${b.getHours()}:${b.getMinutes()}:${b.getSeconds()}`
		const start = new Date(begin).getTime() / 1000

		const d = new Date(form.value1[1])
		const finish = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
		const over = new Date(finish).getTime() / 1000

		ruleFormRef.value.validate((valid) => {
			if (valid === true) {
				ConfirmLoading.value = true

				// 构造提交的 content：保持题目结构，为后端解析保留 id/option 等
				const data = {
					isRandomlyQuestions: form.random,
					isDayAnswer: form.restrictive,
					dayAnswer: form.frequency,
					isRanking: form.exhibition,
					isLog: form.record,
					unionCode: Hcode.value,
					title: form.name,
					startTime: start,
					endTime: over,
					isEnable: form.enable,
					rule: form.desc,
					seeing: form.sex,
					imageUrl: dizhi.value,
					content: topics.value,
					category: form.pattern,
					isSetTime: form.isSetTime,
					setTime: form.setTime,
					isWalk: form.strides,
					stepsNumber: form.reach,
					answerStandard: form.problem,
					questionsNumber: form.einmal,
				}

				DTadd(qs.parse(data)).then((res) => {
					if (res && res.data && res.data.code === 0) {
						ElMessage({ message: '提交成功', type: 'success', center: true })
						// 清理表单（保留最小初始状态）
						setTimeout(() => {
							form.name = ''
							form.desc = ''
							form.sex = ''
							form.enable = ''
							dizhi.value = ''
							topics.value = [
								{
									id: genId('q_'),
									name: '',
									type: '1',
									isRequired: '1',
									option: [],
								},
							]
							form.pattern = ''
							form.strides = ''
							form.reach = ''
							form.problem = ''
							form.einmal = ''
							Hcode.value = ''
							form.Mars = ''
							form.random = ''
							form.restrictive = ''
							form.exhibition = ''
							form.record = ''
							form.frequency = ''
							form.value1 = ''
							if (qingkong.value && qingkong.value.clearFiles) qingkong.value.clearFiles()
							styA.value = 0
							const current = route.path
							const expression = store.state.tagsList
							let Indexs = null
							expression.forEach((item, index) => {
								if (current === item.path) Indexs = index
							})
							if (Indexs !== null) store.state.tagsList.splice(Indexs, 1)
							router.push({ name: 'answer', params: { userId: 1 } })
							ConfirmLoading.value = false
						}, 0)
					} else {
						ElMessage({ message: (res && res.data && res.data.msg) || '提交失败', type: 'error', center: true })
						ConfirmLoading.value = false
					}
				}).catch((err) => { if (err?.isAuthExpired) return;
					console.error(err)
					ElMessage({ message: '提交失败', type: 'error', center: true })
					ConfirmLoading.value = false
				})
			} else {
				ElMessage({ message: '提交失败', type: 'error', center: true })
				ConfirmLoading.value = false
			}
		})
	} catch (err) {
		console.error(err)
		ElMessage({ message: '时间数据异常，请检查', type: 'error', center: true })
	}
}

// mount
onMounted(() => {
	lang()
})

/* 返回给 template 的内容（setup script 中直接定义即可） */
</script>

<style lang="scss" scoped>
/* 原样式全部保留（你提供的样式） */
.shallow {
	color: #ffffff;
	border: none;
	--el-button-bg-color: #00BFFF;
	--el-button-hover-bg-color: #87CEFA;
	--el-button-hover-text-color: #ffffff;
}

.shallow:hover {
	color: #ffffff;
}

.correct {
	margin-left: 10px;
}
.sheet_rifht{
	flex: 1;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
	-webkit-appearance: none !important;
}

.aaaass {
	width: 18.5%;
}

.button {
	margin-left: 6.5%;
}

::v-deep .chart-card::-webkit-scrollbar {
	display: none
}

::v-deep .chart-card {
	height: calc(100vh - 145px);
	overflow: auto;
}

::v-deep .fortify {
	display: flex;
	align-items: center;
}

::v-deep .subs {
	font-size: 14px;
	color: var(--el-text-color-regular);
	margin-left: 2px;
	margin-right: 10px;
}

::v-deep .tance {
	display: flex;
	flex-direction: column;
	margin-left: 11px;
}

::v-deep .twist {
	margin-left: 13px;
	margin-top: 8px;
	margin-bottom: 20px;
}

::v-deep .dati {
	font-weight: bold;
	width: 76px;
	display: flex;
	font-size: 14px;
	justify-content: flex-end;
	margin-top: 13px;
	color: var(--el-text-color-regular);

	span {
		color: var(--el-color-danger);
		margin-right: 3px;
	}
}

::v-deep .sheet {
	display: flex;
}

::v-deep .gao {
	height: 10px;
}

::v-deep .red,
.red:focus:not(.red:hover) {
	color: red;
}

::v-deep .red {
	font-size: 20px;
	color: red;
	border: none;
	--el-button-bg-color: none;
	--el-button-hover-bg-color: none;
	--el-button-hover-text-color: none;
}

::v-deep .red:hover {
	color: #fab6b6;
}

::v-deep .bulur,
.bulur:focus:not(.bulur:hover) {
	color: #409eff;
}

::v-deep .bulur {
	color: #409eff;
	border: none;
	--el-button-bg-color: none;
	--el-button-hover-bg-color: none;
	--el-button-hover-text-color: none;
}

::v-deep .bulur:hover {
	color: #a0cfff;
}

::v-deep .cancel {
	margin-right: 5px;
	font-weight: 400;
}

::v-deep .circus {
	display: flex;
	align-items: center;
	width: 100%;
	margin-top: 10px;
}

::v-deep .circu {
	display: flex;
	align-items: center;
	width: 100%;
}

::v-deep .lation {
	width: 100%;
}

::v-deep .shuomings {
	width: 50%;
	margin-bottom: 50px;
}

::v-deep .shuoming {
	width: 100%;
}

::v-deep .el-textarea {
	width: 50%;
}

::v-deep .el-button {
	width: 100px;
	height: 40px;
	font-size: 16px;
}

::v-deep .el-form-item__content {
	align-items: flex-end;
}

::v-deep .referrals {
	color: #cccccc;
	margin-left: 5px;
}

::v-deep .styB .el-upload--picture-card {
	width: 110px;
	height: 110px;
	line-height: 110px;
}

::v-deep .styC .el-upload--picture-card {
	display: none;
}

::v-deep .el-form-item {
	align-items: center;
}

::v-deep .aaaa {
	width: 50%;
}

::v-deep .el-card__body {
	padding: 0;
}

::v-deep .el-main {
	overflow: auto !important;
}

::v-deep .el-card.is-always-shadow {
	width: 95%;
	margin: auto;
	padding-left: 20px;
	padding-right: 20px;
	padding-bottom: 20px;
	margin-top: 10px;
}

::v-deep .tabulation {
	margin-top: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 10px;
	overflow: auto !important;
}
</style>

<style scoped>
::v-deep .upload-demo {
	display: flex;
}

::v-deep .el-input {
	height: 44px !important;
}

::v-deep .el-form-item__label {
	width: 80px !important;
	font-weight: bold;
}
</style>
